import React from 'react'
import { connect } from 'react-redux'
import { NumberFormatBase } from 'react-number-format'

const TelInput = (props) => {
    const {
        label,
        specialOnChange,
        input,
        require,
        disabled = false,
        fixedDecimalScale = false,
        textAlignLeft,
        allowNegative = true,
        placeholder,
        formatValue = null,
        meta: { touched, error }
    } = props

    return (
        <div className="w-full px-3 ">
            <label className="block text-left tracking-wide text-gray-800 font-bold text-sm mb-2" >
                {label}
                {require ? <span className='ml-2 text-red-500 require'>*</span> : null}
                {touched && error ? <span className='ml-2 text-red-500 require'>{error}</span> : null}
            </label>
            <NumberFormatBase
                className={`text-base appearance-none outline-none focus:outline-none block w-full text-gray-800 border border-[#FBC558] rounded py-3 px-4 mb-3 leading-tight`}
                name={input.name}
                defaultValue={0}
                value={input.value}
                allowNegative={allowNegative}
                disabled={disabled}
                placeholder={placeholder}
                // format={formatValue}
                onValueChange={values => {
                    input.onChange(values.value)
                    if (specialOnChange) {
                        specialOnChange(values.value)
                    }
                }}
                isAllowed={(values) => {
                    const { formattedValue } = values;
                    // จำกัดตัวอักษรสูงสุด 10 ตัว
                    return formattedValue.length <= 10;
                }}
                style={{ textAlign: textAlignLeft ? '' : 'left', backgroundColor: disabled ? "#3b3b3b0a" : touched && error ? "#FFF0F0" : "", borderColor: '#FBC558', opacity: 1, lineHeight: '1.2' }}
            />
        </div>
    )
}

const mapStateToProps = (state) => {
    return {}
}

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(TelInput)
